import { render, staticRenderFns } from "./newDocumentExtract.vue?vue&type=template&id=267f537e&scoped=true"
import script from "./newDocumentExtract.vue?vue&type=script&lang=js"
export * from "./newDocumentExtract.vue?vue&type=script&lang=js"
import style0 from "./newDocumentExtract.vue?vue&type=style&index=0&id=267f537e&prod&lang=less&scoped=true"
import style1 from "./newDocumentExtract.vue?vue&type=style&index=1&id=267f537e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f537e",
  null
  
)

export default component.exports